<template>
  <div class="futureoption-modal">
    <a-modal
      class="page-modal"
      v-model:visible="modalVisible"
      :title="isEdit ? 'Edit ' + localForm.assetClass : 'Add FUTURE/OPTION'"
      :style="{ top: '32px', width: '1200px' }"
      @ok="handleOk"
      @cancel="handleCancel"
      :confirmLoading="loading"
      destroyOnClose
    >
      <a-form
        ref="addFormRef"
        :model="localForm"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        :rules="formRules"
      >
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item label="SecurityId" v-if="isEdit">
              <a-input
                v-model:value="localForm.securityId"
                :disabled="isEdit"
              />
            </a-form-item>
            <a-form-item label="ExternalSecurityId" v-if="isEdit">
              <a-input
                v-model:value="localForm.externalSecurityId"
                :disabled="isEdit"
              />
            </a-form-item>
            <a-form-item label="Exchange" name="exchange">
              <a-select
                v-model:value="localForm.exchange.exchangeId"
                allow-clear
                :show-search="true"
                :filter-option="filterOption"
              >
                <a-select-option
                  v-for="item in exchangeList"
                  :key="item.exchName"
                  :value="item.exchangeId"
                >
                  {{ item.exchName }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Issuer">
              <a-select
                v-model:value="localForm.issuer.issuerId"
                allow-clear
                :show-search="true"
                :filter-option="filterOption"
              >
                <a-select-option
                  v-for="item in issuerList"
                  :key="item.name"
                  :value="item.issuerId"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="Asset Class" name="assetClass">
              <a-select
                v-model:value="localForm.assetClass"
                :show-search="true"
              >
                <a-select-option
                  v-for="item in assetClassList"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="Inst Class" name="instrumentClass">
              <a-select
                v-if="localForm.assetClass === 'FUTURE'"
                v-model:value="localForm.instrumentClass"
                allow-clear
                :show-search="true"
                :filter-option="filterOption"
              >
                <a-select-option
                  v-for="item in futureInstClassList"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
              <a-select
                v-else
                v-model:value="localForm.instrumentClass"
                :show-search="true"
                :filter-option="filterOption"
              >
                <a-select-option
                  v-for="item in optionInstClassList"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="Sec Type">
              <SecTypeInput v-model:value="localForm.securityType" />
            </a-form-item>

            <a-form-item label="BB_TCM" name="ticker">
              <a-input
                v-if="isAutoTicker"
                disabled
                placeholder="Auto-generated on create"
              />
              <a-input v-else v-model:value="localForm.ticker" />
            </a-form-item>

            <a-form-item label="ISIN">
              <a-input v-model:value="localForm.isin" />
            </a-form-item>

            <a-form-item label="Desc" name="desc">
              <a-input
                v-if="isAutoTicker"
                disabled
                placeholder="Defaults to BB_TCM"
              />
              <a-input v-else v-model:value="localForm.desc" />
            </a-form-item>
            <a-form-item label="Underlying BB_TCM">
              <a-auto-complete
                v-model:value="localForm.underlyingTicker"
                :options="underlyingOptions"
                @search="onSearchUnderlying"
                @select="onSelectUnderlying"
              />
            </a-form-item>

            <a-form-item label="Price Multiplier" name="priceMultiplier">
              <a-input-number
                v-model:value="localForm.priceMultiplier"
                style="width: 100%"
              />
            </a-form-item>

            <a-form-item label="Contract Size" name="contractSize">
              <a-input-number
                v-model:value="localForm.contractSize"
                style="width: 100%"
              />
            </a-form-item>

            <a-form-item label="Maturity Date" name="maturityDate">
              <a-date-picker
                v-model:value="localForm.maturityDate"
                style="width: 100%"
                format="YYYY-MM-DD"
              />
            </a-form-item>

            <a-form-item label="Settlement Type" name="settlementType">
              <a-select v-model:value="localForm.settlementType">
                <a-select-option
                  v-for="item in settlementTypeList"
                  :key="item.desc"
                  :value="item.code"
                >
                  {{ item.desc }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="Tick Size" name="tickSize">
              <a-input-number
                v-model:value="localForm.tickSize"
                style="width: 100%"
              />
            </a-form-item>

            <a-form-item label="Tick Value" name="tickValue">
              <a-input-number
                v-model:value="localForm.tickValue"
                style="width: 100%"
              />
            </a-form-item>

            <a-form-item
              v-if="localForm.assetClass === 'FUTURE'"
              label="Price Quotation Type"
            >
              <a-select
                v-model:value="localForm.priceQuotationType"
                allow-clear
                :show-search="true"
                :filter-option="filterOption"
              >
                <a-select-option
                  v-for="item in priceQuotationTypeList"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item v-else label="Price Quotation Type">
              <a-select
                v-model:value="localForm.priceQuotationType"
                allow-clear
                :show-search="true"
                :filter-option="filterOption"
              >
                <a-select-option
                  v-for="item in priceQuotationTypeOptionList"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="Pnl Currency" name="pnlCurrency">
              <a-select
                v-model:value="localForm.pnlCurrency"
                allow-clear
                :show-search="true"
                :filter-option="filterOption"
              >
                <a-select-option
                  v-for="item in currencyList"
                  :key="item.currencyCode"
                  :value="item.currencyCode"
                >
                  {{ item.currencyCode }} - {{ item.currencyDesc }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="First Trade Date">
              <a-date-picker
                v-model:value="localForm.firstTradeDate"
                style="width: 100%"
                format="YYYY-MM-DD"
              />
            </a-form-item>

            <a-form-item label="Last Trade Date">
              <a-date-picker
                v-model:value="localForm.lastTradeDate"
                style="width: 100%"
                format="YYYY-MM-DD"
              />
            </a-form-item>

            <a-form-item label="Status">
              <a-select v-model:value="localForm.isActive" style="width: 100%">
                <a-select-option :value="true">ACTIVE</a-select-option>
                <a-select-option :value="false">INACTIVE</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="1">
            <a-divider type="vertical" style="height: 100%; width: 2px" />
          </a-col>
          <a-col :span="11">
            <a-form-item
              label="First Notice Date"
              v-if="localForm.assetClass === 'FUTURE'"
              :labelCol="{ width: '120px' }"
            >
              <a-date-picker
                v-model:value="localForm.firstNoticeDate"
                style="width: 100%"
                format="YYYY-MM-DD"
              />
            </a-form-item>

            <a-form-item
              v-if="
                localForm.assetClass === 'OPTION' &&
                localForm.instrumentClass !== 'FX_OP'
              "
              label="Call Put"
              name="callPut"
              :labelCol="{ span: 8, style: { textAlign: 'left' } }"
              :wrapperCol="{ span: 16 }"
            >
              <a-select
                v-model:value="localForm.callPut"
                allow-clear
                :show-search="true"
                :filter-option="filterOption"
              >
                <a-select-option
                  v-for="item in callPutList"
                  :key="item.desc"
                  :value="item.code"
                >
                  {{ item.desc }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item
              label="Exercise Style"
              name="exerciseStyle"
              v-if="
                localForm.assetClass === 'OPTION' &&
                localForm.instrumentClass !== 'FX_OP'
              "
            >
              <a-select
                v-model:value="localForm.exerciseStyle"
                allow-clear
                :show-search="true"
                :filter-option="filterOption"
              >
                <a-select-option
                  v-for="item in exerciseStyleList"
                  :key="item.desc"
                  :value="item.code"
                >
                  {{ item.desc }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item
              v-if="
                localForm.assetClass === 'OPTION' &&
                localForm.instrumentClass !== 'FX_OP'
              "
              label="Exercise Price Currency"
              name="exercisePriceCurrency"
            >
              <a-select
                v-model:value="localForm.exercisePriceCurrency"
                allow-clear
                :show-search="true"
                :filter-option="filterOption"
              >
                <a-select-option
                  v-for="item in currencyList"
                  :key="item.currencyCode"
                  :value="item.currencyCode"
                >
                  {{ item.currencyCode }} - {{ item.currencyDesc }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item
              v-if="localForm.assetClass === 'OPTION'"
              label="Exercise Price"
              name="exercisePrice"
              :labelCol="{ span: 8, style: { textAlign: 'left' } }"
              :wrapperCol="{ span: 16 }"
            >
              <a-input-number
                v-model:value="localForm.exercisePrice"
                style="width: 100%"
              />
            </a-form-item>

            <a-form-item
              v-if="localForm.assetClass === 'OPTION'"
              label="Exercise Price Multiplier"
              name="exercisePriceMultiplier"
              :labelCol="{ span: 8, style: { textAlign: 'left' } }"
              :wrapperCol="{ span: 16 }"
            >
              <a-input-number
                v-model:value="localForm.exercisePriceMultiplier"
                style="width: 100%"
              />
            </a-form-item>

            <a-form-item
              v-if="
                localForm.assetClass === 'OPTION' &&
                localForm.instrumentClass === 'FX_OP'
              "
              label="Option Type"
              name="optionType"
            >
              <a-select
                v-model:value="localForm.optionType"
                allow-clear
                :show-search="true"
                :filter-option="filterOption"
              >
                <a-select-option
                  v-for="item in optionTypeList"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-tabs
              type="card"
              v-if="
                localForm.assetClass === 'OPTION' &&
                localForm.instrumentClass === 'FX_OP'
              "
            >
              <a-tab-pane
                key="Leg1"
                tab="Leg1"
                v-if="
                  localForm.assetClass === 'OPTION' &&
                  localForm.instrumentClass === 'FX_OP'
                "
              >
                <AddEditFxOptionView
                  ref="leg1FormRef"
                  :leg="leg1"
                  :required="isAutoTicker"
                />
              </a-tab-pane>
              <a-tab-pane
                key="Leg2"
                tab="Leg2"
                v-if="
                  localForm.assetClass === 'OPTION' &&
                  localForm.instrumentClass === 'FX_OP' &&
                  localForm.optionType === 'DUALDIGITAL'
                "
                ><AddEditFxOptionView
                  ref="leg2FormRef"
                  :leg="leg2"
                  :required="isAutoTicker"
              /></a-tab-pane>
            </a-tabs>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, computed, inject, watch } from 'vue'
import { useStore } from 'vuex'
import SecTypeInput from '@/components/SecTypeInput.vue'
import AddEditFxOptionView from './AddEditFxOptionView.vue'
import debounce from 'lodash/debounce'
import { message } from 'ant-design-vue'
import dayjs from 'dayjs'

const store = useStore()

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
  isEdit: {
    type: Boolean,
    default: false,
  },
  addForm: {
    type: Object,
    required: true,
  },
})

const wrapperCol = {
  span: 24,
}
const labelCol = {
  span: 8,
  style: { textAlign: 'left' },
}

const exchangeList = inject('exchangeList', ref([]))
const issuerList = inject('issuerList', ref([]))
const futureInstClassList = inject('futureInstClassList', ref([]))
const optionInstClassList = inject('optionInstClassList', ref([]))
const security = inject('security')
const assetClassList = ['FUTURE', 'OPTION']
const settlementTypeList = [
  { code: 'C', desc: 'CASH' },
  { code: 'P', desc: 'PHYSICAL' },
]
const priceQuotationTypeList = [
  '100_M_IR',
  'ANZ_FUT_10YR_6PCT',
  'ANZ_FUT_3YR_6PCT',
  'ANZ_FUT_90DAY_BILL',
  'INDX_PTS',
  'P_PER_TONNES',
]
const priceQuotationTypeOptionList = ['INDX_PTS', 'P_PER_SHARE']
const callPutList = [
  { code: 'C', desc: 'CALL' },
  { code: 'P', desc: 'PUT' },
]
const exerciseStyleList = [
  { code: 'E', desc: 'EUROPEAN' },
  { code: 'A', desc: 'AMERICAN' },
]
const optionTypeList = [
  'DIGITAL',
  'DOUBLE',
  'DOUBLENOTOUCH',
  'DOUBLEONETOUCH',
  'DUALDIGITAL',
  'NOTOUCH',
  'ONETOUCH',
  'SINGLE',
  'TOUCH',
  'VANILLA',
]
const underlyingOptions = ref([])
const tickerList = ref([])

const addFormRef = ref(null)
const leg1FormRef = ref(null)
const leg2FormRef = ref(null)
const loading = ref(false)
const localForm = ref(props.addForm)
const leg1 = ref(null)
const leg2 = ref(null)
const rules = ref({
  assetClass: [{ required: true, message: 'Please input assetClass' }],
  instrumentClass: [
    { required: true, message: 'Please input instrumentClass' },
  ],
  desc: [{ required: true, message: 'Please input name' }],
  ticker: [{ required: true, message: 'Please input BB_TCM' }],
  issuer: [{ required: true, message: 'Please select issuer' }],
  maturityDate: [{ required: false, message: 'Please input maturityDate' }],
  priceMultiplier: [
    { required: true, message: 'Please input priceMultiplier' },
  ],
  contractSize: [{ required: true, message: 'Please input contractSize' }],
  settlementType: [{ required: true, message: 'Please select settlementType' }],
  tickSize: [{ required: true, message: 'Please input tickSize' }],
  tickValue: [{ required: true, message: 'Please input tickValue' }],
  pnlCurrency: [{ required: true, message: 'Please select PnL ccy' }],
  exchange: [{ required: true, message: 'Please select exchange' }],
  priceDivisor: [{ required: true, message: 'Please input price divisor' }],
  accrualDate: [{ required: true, message: 'Please input accrual date' }],
})

// New FX options get their BB_TCM (and name/desc) generated by sm-svc
// Option.createIdentifier(), which only runs when no identifier is sent.
const isAutoTicker = computed(
  () => !props.isEdit && localForm.value.instrumentClass === 'FX_OP'
)

const formRules = computed(() =>
  isAutoTicker.value
    ? {
        ...rules.value,
        ticker: [],
        desc: [],
        optionType: [{ required: true, message: 'Please select option type' }],
      }
    : rules.value
)

const currencyList = computed(() => {
  const currencies = store.getters['reference/getCurrencyList'] || []
  return [...currencies].sort((a, b) =>
    a.currencyCode.localeCompare(b.currencyCode)
  )
})

const emit = defineEmits(['update:visible', 'update:security'])

const modalVisible = computed({
  get: () => props.visible,
  set: (val) => emit('update:visible', val),
})

const userName = computed(() => store.getters['auth/getUserName'] || 'Guest')

watch(
  () => props.addForm,
  (newVal) => {
    localForm.value = newVal
    leg1.value = null
    leg2.value = null
    if (localForm.value.instrumentClass === 'FX_OP') {
      if (localForm.value.optionType !== 'DUALDIGITAL') {
        leg1.value = localForm.value
      } else {
        if (props.addForm.leg1) {
          leg1.value = {
            ...localForm.value.leg1,
            exchange: { ...props.addForm.leg1.exchange },
            issuer: { ...props.addForm.leg1.issuer },
            identifiers: props.addForm.leg1.identifiers
              ? [...props.addForm.leg1.identifiers]
              : [],
            underlying: { ...props.addForm.leg1.underlying },
          }
        } else {
          leg1.value = newLeg()
        }
        if (props.addForm.leg2) {
          leg2.value = {
            ...props.addForm.leg2,
            exchange: { ...props.addForm.leg2.exchange },
            issuer: { ...props.addForm.leg2.issuer },
            identifiers: props.addForm.leg1.identifiers
              ? [...props.addForm.leg2.identifiers]
              : [],
            underlying: { ...props.addForm.leg2.underlying },
          }
        } else {
          leg2.value = newLeg()
        }
      }
    }
  },
  {
    immediate: true,
  }
)

watch(
  () => localForm.value.assetClass,
  (newValue) => {
    rules.value = {
      ...rules.value,
      maturityDate: [
        {
          required: newValue === 'OPTION',
          message: 'Please select maturity date',
        },
      ],
      callPut: [
        {
          required: newValue === 'OPTION',
          message: 'Please select callPut',
        },
      ],
      exerciseStyle: [
        {
          required: newValue === 'OPTION',
          message: 'Please input Exercise Style',
        },
      ],
      exercisePriceCurrency: [
        {
          required: newValue === 'OPTION',
          message: 'Please select Exercise Price Currency',
        },
      ],
      exercisePrice: [
        {
          required: newValue === 'OPTION',
          message: 'Please input Exercise Price',
        },
      ],
      exercisePriceMultiplier: [
        {
          required: newValue === 'OPTION',
          message: 'Please input Exercise Price Multiplier',
        },
      ],
      underlyingTicker: [
        {
          required: newValue === 'OPTION',
          message: 'Please select underlying',
        },
      ],
    }
  },
  { immediate: true }
)

watch(
  () => localForm.value.instrumentClass,
  (newValue) => {
    if (newValue === 'FX_OP' && localForm.value.optionType !== 'DUALDIGITAL') {
      if (!leg1.value || (!props.isEdit && leg1.value.securityId)) {
        leg1.value = localForm.value
      }
    }
  },
  { immediate: true }
)
watch(
  () => localForm.value.optionType,
  (newValue, oldValue) => {
    if (newValue !== oldValue && newValue === 'DUALDIGITAL') {
      if (!leg1.value || (!props.isEdit && leg1.value.securityId)) {
        leg1.value = newLeg()
      }

      if (!leg2.value || (!props.isEdit && leg2.value.securityId)) {
        leg2.value = newLeg()
      }
    }
  },
  { immediate: true }
)

watch(
  () => leg1.value?.broker ?? null,
  (newValue) => {
    if (localForm.value.optionType === 'DUALDIGITAL') {
      if (leg2.value) {
        leg2.value.broker = newValue
      }
      localForm.value.broker = newValue
    }
  },
  { immediate: true }
)

watch(
  () => leg2.value?.broker ?? null,
  (newValue) => {
    if (leg1.value) {
      leg1.value.broker = newValue
    }
  },
  { immediate: true }
)

watch(
  () => leg1.value?.premiumCcy ?? null,
  (newValue) => {
    if (leg2.value) {
      leg2.value.premiumCcy = newValue
    }
  },
  { immediate: true }
)

watch(
  () => leg2.value?.premiumCcy ?? null,
  (newValue) => {
    if (leg1.value) {
      leg1.value.premiumCcy = newValue
    }
  },
  { immediate: true }
)

watch(
  () => leg1.value?.isBilateral ?? null,
  (newValue) => {
    if (localForm.value.optionType === 'DUALDIGITAL') {
      if (leg2.value) {
        leg2.value.isBilateral = newValue
      }
      localForm.value.isBilateral = newValue
    }
  },
  { immediate: true }
)

watch(
  () => leg2.value?.isBilateral ?? null,
  (newValue) => {
    if (localForm.value.optionType === 'DUALDIGITAL') {
      if (leg1.value) {
        leg1.value.isBilateral = newValue
        localForm.value.isBilateral = newValue
      }
    }
  },
  { immediate: true }
)

watch(
  () => leg1.value?.exercisePrice ?? null,
  (newValue) => {
    if (localForm.value.optionType === 'DUALDIGITAL') {
      localForm.value.exercisePrice = newValue
    }
  },
  { immediate: true }
)

watch(
  () => leg1.value?.maturityDate ?? null,
  (newValue) => {
    if (localForm.value.optionType === 'DUALDIGITAL') {
      localForm.value.maturityDate = newValue
    }
  },
  { immediate: true }
)

watch(
  () => leg1.value?.settleDate ?? null,
  (newValue) => {
    if (localForm.value.optionType === 'DUALDIGITAL') {
      localForm.value.settleDate = newValue
    }
  },
  { immediate: true }
)

watch(
  () => leg1.value?.settlementType ?? null,
  (newValue) => {
    if (localForm.value.optionType === 'DUALDIGITAL') {
      localForm.value.settlementType = newValue
    }
  },
  { immediate: true }
)
watch(
  () => leg1.value?.premiumCcy ?? null,
  (newValue) => {
    if (localForm.value.optionType === 'DUALDIGITAL') {
      localForm.value.premiumCcy = newValue
      localForm.value.pnlCurrency = newValue
    }
  },
  { immediate: true }
)
const newLeg = () => {
  return {
    assetClass: 'OPTION',
    instrumentClass: 'FX_OP',
    optionType: 'DIGITAL',
    symbol: undefined,
    broker: undefined,
    isBilateral: false,
    amt: undefined,
    amtCcy: undefined,
    exercisePrice: 1,
    exerciseStyle: 'E',
    maturityDate: null,
    settleDate: null,
    callPut: 'C',
    payout: 'INSTANT',
    settlementType: 'P',
  }
}

const filterOption = (input, option) => {
  const key = option?.key ?? option?.value ?? ''
  return String(key).toLowerCase().includes(input.toLowerCase())
}

const searchUnderlying = (ticker) => {
  if (!ticker || ticker.length < 3) {
    return
  }
  security.getSecurityStartWith({ ticker }).then((res) => {
    const data = Array.isArray(res.data) ? res.data : []
    tickerList.value = data
    const underlyingTickers = data
      .filter((item) => item.ticker)
      .map((item) => item.ticker)
    underlyingTickers.sort((a, b) => b.localeCompare(a))
    const arr =
      underlyingTickers.length > 8
        ? underlyingTickers.slice(0, 8)
        : underlyingTickers
    underlyingOptions.value = arr.map((item) => ({ value: item }))
  })
}
const onSearchUnderlying = debounce(
  function (underlyingTicker) {
    searchUnderlying(underlyingTicker)
  },
  600,
  { maxWait: 1000 }
)

const onSelectUnderlying = async (value) => {
  localForm.value.underlyingTicker = value
  const res = await security.getSecurityStartWith({ ticker: value })
  const underlying = res.data?.[0]
  if (!underlying) {
    return
  }
  underlying.pnlCurrency = underlying.pnlCcyCode
  localForm.value.underlying = underlying
}

const getCcy = (leg) => {
  let symbol = leg.symbol
  let premiumCcy = leg.premiumCcy
  let ccy = null
  if (premiumCcy) {
    ccy = symbol.replace('/', '').replace(premiumCcy, '')
  }
  return ccy
}

const getErrorMessage = (error, fallback) =>
  error?.response?.data?.message || fallback

const formatDateTime = (val) =>
  val ? dayjs(val).format('YYYY-MM-DDTHH:mm:ss') : null

const buildPayload = () => {
  const lastModifiedOn = dayjs().format('YYYY-MM-DDTHH:mm:ss')
  const payload = {
    ...localForm.value,
    name: localForm.value.desc,
    exchange: { ...localForm.value.exchange },
    issuer: { ...localForm.value.issuer },
    identifiers: [],
    underlying: localForm.value.underlying
      ? { ...localForm.value.underlying }
      : null,
    // leg1: leg1.value ? { ...leg1.value } : null,
    // leg2: leg2.value ? { ...leg2.value } : null,
    issueDate: formatDateTime(localForm.value.issueDate),
    maturityDate: formatDateTime(localForm.value.maturityDate),
    firstTradeDate: formatDateTime(localForm.value.firstTradeDate),
    lastTradeDate: formatDateTime(localForm.value.lastTradeDate),
    firstNoticeDate: formatDateTime(localForm.value.firstNoticeDate),
    settleDate: formatDateTime(localForm.value.settleDate),
    firstExerciseDate: formatDateTime(localForm.value.firstExerciseDate),
    winStartDate: formatDateTime(localForm.value.winStartDate),
    winEndDate: formatDateTime(localForm.value.winEndDate),
    expiryTime: localForm.value.expiryTime
      ? dayjs(localForm.value.expiryTime, 'HH:mm:ss').format('HH:mm:ss')
      : null,
    lastModifiedOn,
    lastModifiedBy: userName.value,
  }

  if (isAutoTicker.value) {
    payload.ticker = null
    payload.desc = null
    payload.name = null
  }

  if (payload.ticker) {
    payload.identifiers.push({
      type: 'BB_TCM',
      value: payload.ticker,
    })
  }
  if (payload.isin) {
    payload.identifiers.push({
      type: 'ISIN',
      value: payload.isin,
    })
  }

  const selectedExchange = exchangeList.value.find(
    (item) => item.exchangeId === payload.exchange.exchangeId
  )
  if (selectedExchange) {
    payload.exchange = {
      exchangeId: selectedExchange.exchangeId,
      exchName: selectedExchange.exchName,
      micExchName: selectedExchange.micExchName,
    }
  }

  if (payload.underlyingTicker) {
    const underlyingIdentifiers = [
      {
        type: 'BB_TCM',
        value: payload.underlyingTicker,
        securityId: payload.underlying?.securityId,
        pnlCurrency: payload.underlying?.pnlCurrency,
      },
    ]
    if (!payload.underlying) payload.underlying = {}
    payload.underlying.identifiers = underlyingIdentifiers
    payload.underlying.instrumentClass = 'DUMMY'
  }
  if (payload.assetClass === 'FUTURE') {
    payload.deliveryDate = payload.maturityDate
  }
  if (payload.assetClass === 'OPTION' && payload.instrumentClass === 'FX_OP') {
    const assetClass = payload.assetClass
    const instrumentClass = payload.instrumentClass

    if (payload.optionType === 'DUALDIGITAL') {
      payload.leg1 = leg1.value ? { ...leg1.value } : null
      const ccy = getCcy(payload.leg1)
      payload.leg1.maturityDate = formatDateTime(payload.leg1.maturityDate)
      payload.leg1.settleDate = formatDateTime(payload.leg1.settleDate)
      payload.leg1.winStartDate = formatDateTime(payload.leg1.winStartDate)
      payload.leg1.winEndDate = formatDateTime(payload.leg1.winEndDate)
      payload.leg1.expiryTime = payload.leg1.expiryTime
        ? dayjs(payload.leg1.expiryTime, 'HH:mm:ss').format('HH:mm:ss')
        : null
      payload.symbol = payload.leg1.symbol
      payload.callPut = payload.leg1.callPut
      payload.exerciseStyle = payload.leg1.exerciseStyle
      payload.exercisePriceCurrency = ccy

      payload.leg1.assetClass = assetClass
      payload.leg1.instrumentClass = instrumentClass
      payload.leg1.optionType = 'DIGITAL'
      payload.leg1.exercisePriceCurrency = ccy
      payload.leg1.pnlCurrency = payload.leg1.premiumCcy
      payload.leg1.underlying = payload.underlying
      payload.leg1.lastModifiedOn = lastModifiedOn
      payload.leg1.lastModifiedBy = lastModifiedOn

      payload.leg2 = leg2.value ? { ...leg2.value } : null
      payload.leg2.assetClass = assetClass
      payload.leg2.instrumentClass = instrumentClass
      payload.leg2.optionType = 'DIGITAL'
      payload.leg2.exercisePriceCurrency = getCcy(payload.leg2)
      payload.leg2.pnlCurrency = payload.leg2.premiumCcy
      payload.leg2.maturityDate = formatDateTime(payload.leg2.maturityDate)
      payload.leg2.settleDate = formatDateTime(payload.leg2.settleDate)
      payload.leg2.winStartDate = formatDateTime(payload.leg2.winStartDate)
      payload.leg2.winEndDate = formatDateTime(payload.leg2.winEndDate)
      payload.leg2.expiryTime = payload.leg2.expiryTime
        ? dayjs(payload.leg2.expiryTime, 'HH:mm:ss').format('HH:mm:ss')
        : null
      payload.leg2.underlying = payload.underlying
      payload.leg2.lastModifiedOn = lastModifiedOn
      payload.leg2.lastModifiedBy = lastModifiedOn
    } else {
      const ccy = getCcy(payload)
      payload.pnlCurrency = payload.premiumCcy
      payload.exercisePriceCurrency = ccy
    }
  }

  return payload
}

const handleOk = async () => {
  try {
    await addFormRef.value?.validate()
  } catch (error) {
    message.warning(getErrorMessage(error, 'Please complete required fields'))
    return
  }

  // Leg fields live in nested forms (and an unopened tab is not rendered),
  // so validate them separately.
  if (isAutoTicker.value) {
    const legRefs = [leg1FormRef]
    if (localForm.value.optionType === 'DUALDIGITAL') legRefs.push(leg2FormRef)
    for (const [i, legRef] of legRefs.entries()) {
      try {
        if (!legRef.value) throw new Error()
        await legRef.value.validate()
      } catch (error) {
        message.warning(`Please complete required fields in Leg${i + 1}`)
        return
      }
    }
  }

  loading.value = true
  try {
    const payload = buildPayload()
    if (props.isEdit) {
      await security.updateSec(payload)
      message.success('Security updated successfully')
    } else {
      const res = await security.createSec(payload)
      const createdTicker = res?.data?.ticker
      message.success(
        isAutoTicker.value && createdTicker
          ? `Security created successfully: ${createdTicker}`
          : 'Security created successfully'
      )
    }
    modalVisible.value = false
  } catch (error) {
    message.error(
      getErrorMessage(
        error,
        props.isEdit ? 'Failed to update security' : 'Failed to create security'
      )
    )
  } finally {
    loading.value = false
  }
}

const handleCancel = () => {
  modalVisible.value = false
}
</script>
